module.exports = __webpack_public_path__ + "media/images/emblems/Prevondavaux-coat_of_arms-9d2a898aebb438c4907d8e870b276c9c.svg";